import actions from '@/store/modules/inventory/actions'
import getters from '@/store/modules/inventory/getters'
import mutations from '@/store/modules/inventory/mutations'
import state from '@/store/modules/inventory/state'

export default {
    actions,
    getters,
    mutations,
    state
}